const translations = {
  "en": {
    "Unsupported chart type": "Unsupported chart type"
  },
  "zh-tw": {
    "Unsupported chart type": "不支援的圖表類型"
  }
};

export default translations;
